import React from 'react';
import { Box, Typography } from '@mui/material';
import desktopBannerImage from '../assets/banner-desktop.png';

const ComingSoonPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        py: 6,
        gap: 4,
        bgcolor: 'background.default',
      }}
    >
      <Box
        component="img"
        src={desktopBannerImage}
        alt="Dogwifdreads"
        sx={{
          width: '100%',
          maxWidth: 480,
          height: 'auto',
        }}
      />
      <Typography variant="h2" component="h1">
        Coming Soon
      </Typography>
      <Typography variant="h5" component="p" sx={{ maxWidth: 520, opacity: 0.8 }}>
        Something new from Dogwifdreads. Stay tuned.
      </Typography>
    </Box>
  );
};

export default ComingSoonPage;
